import {
    createStore, applyMiddleware, combineReducers, compose,
} from 'redux';
import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension';
import thunkMiddleware from 'redux-thunk';
import reducers from './reducers';

let store = null;
const composeEnhancers = compose;

const middlewares = [thunkMiddleware];
const enhancers = [applyMiddleware(...middlewares)];

const finalReducers = combineReducers({
    app: reducers,
});

if (process.env.NODE_ENV === 'development')
{
    const devTools = composeWithDevToolsDevelopmentOnly();
    if (devTools) enhancers.push(devTools);
}

store = createStore(finalReducers, {}, composeEnhancers(...enhancers));

const finalStore = store;
export default finalStore;
